<template>
  <div class="scorllFlash" :id="randomId">
    <div v-if="!noNeedFlash" class="reloadFlash">刷新中···</div>
    <div :id="randomId + '_translation'" style="position: relative;z-index: 1">
      <slot></slot>
    </div>
        <!--<div class="getNextPage">正在加载</div>-->
  </div>
</template>

<script>
let time
let pageY
export default {
  name: 'allScorllPlace',
  props: [
    'noNeedFlash'
  ],
  data () {
    return {
      randomId: new Date().getTime() + '_' + (Math.random() * 1000),
      needReflash: false
    }
  },
  created () {
  },
  mounted () {
    let scorllDom = document.getElementById(this.randomId)
    let winDom = document.body
    if (scorllDom) {
      winDom.onscroll = p => {
        // const scrollTop = scorllDom.scrollTop
        // const clientHeight = scorllDom.clientHeight
        const scrollHeight = scorllDom.scrollHeight
        // let winHeight = document.body.clientHeight
        // let winTop = document.documentElement.scrollTop
        let winHeight = winDom.clientHeight
        let winTop = winDom.scrollTop
        // console.log(winTop, winHeight)
        // if (scrollHeight > clientHeight && scrollTop + clientHeight > scrollHeight - 10) {
        if (scrollHeight > winHeight && winTop + winHeight > scrollHeight - 10) {
          p.preventDefault()
        }
        if (scorllDom.scrollTop === 0) {
          this.$emit('hiddenMoveTop', true)
        } else {
          this.$emit('hiddenMoveTop', false)
        }
        clearTimeout(time)
        time = setTimeout(p => {
          // const scrollTop = scorllDom.scrollTop
          // const clientHeight = scorllDom.clientHeight
          const scrollHeight = scorllDom.scrollHeight
          // let winHeight = document.body.clientHeight
          // let winTop = document.documentElement.scrollTop
          let winHeight = winDom.clientHeight
          let winTop = winDom.scrollTop
          // console.log(winTop, winHeight)
          // alert(winTop + ' ' + winHeight + ' ' + scrollHeight)
          // if (scrollHeight > clientHeight && scrollTop + clientHeight > scrollHeight - 10) {
          if (scrollHeight > winHeight && winTop + winHeight > scrollHeight - 10) {
            // alert(winTop + ' ' + winHeight + ' ' + scrollHeight)
            this.$emit('getNextPage')
          }
        }, 300)
      }
      if (!this.noNeedFlash) {
        winDom.ontouchstart = p => {
          console.log(this.needReflash)
          if (this.needReflash) {
            p.preventDefault()
          }
          pageY = p.touches[0].clientY
          this.needReflash = false
        }
        winDom.ontouchmove = p => {
          if (winDom.scrollTop === 0 && pageY < p.touches[0].clientY) {
            p.preventDefault()
            if ((p.touches[0].clientY - pageY) < 30) {
              let scorllDomtranslation = document.getElementById(this.randomId + '_translation')
              if (scorllDomtranslation) {
                scorllDomtranslation.style.transform = 'translateY(' + (p.touches[0].clientY - pageY) + 'px)'
              }
            } else {
              this.needReflash = true
            }
          }
          // pageY = p.touches[0].clientY
        }
        winDom.ontouchend = p => {
          let scorllDomtranslation = document.getElementById(this.randomId + '_translation')
          if (scorllDomtranslation) {
            scorllDomtranslation.style.transform = 'translateY(0px)'
          }
          if (this.needReflash) {
            this.$emit('needReflash')
          }
        }
      }
    }
  },
  methods: {
    kickBack () {
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollTop + 1)
        document.body.scrollTop >= 1 && window.scrollTo(0, document.body.scrollTop - 1)
        if (document.getElementById(this.randomId)) {
          window.scrollTo(0, document.getElementById(this.randomId).scrollTop + 1)
          document.getElementById(this.randomId).scrollTop >= 1 && window.scrollTo(0, document.getElementById(this.randomId).scrollTop - 1)
        }
      }, 10)
    },
    scorllTopClick () {
      let scorllDom = document.getElementById(this.randomId)
      if (scorllDom) {
        scorllDom.scrollTop = 0
      }
    }
  },
  watch: {
  }
}
</script>

<style scoped>
.reloadFlash{
  position: absolute;
  top: 5px;
  width: 100%;
  left: 0;
  text-align: center;
  color: #eee;
}
.getNextPage{
  position: absolute;
  bottom: -30px;
  width: 100%;
  left: 0;
  text-align: center;
  color: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/myComponents/allScorllPlace.vue